import { Link } from '@packages/modules/src/Link/Link';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useTrackCampaignOnLoad } from '@packages/shared/src/hooks/useTrackCampaign/useTrackCampaign';
import { useEffect, type JSX } from 'react';
import { useAssignLinkTargetBasedOnBotStatus } from '../../../hooks/useAssignLinkTargetBasedOnBotStatus';
import { classes } from '../../../utils/classes';
import { PromotionBannerTestIds } from '../PromotionBannerTestIds';
import type { LinkPromotion } from '../types';

export const PromotionAsLink = ({ data }: { data: LinkPromotion }): JSX.Element => {
  const { trackClick, trackDisplay } = useTrackCampaignOnLoad(data);
  const { styleVariant } = useConfig();
  const assignLinkTarget = useAssignLinkTargetBasedOnBotStatus();
  const finalLink = assignLinkTarget(data.linkReady);

  useEffect(() => {
    trackDisplay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Link
      href={finalLink}
      data-testid={PromotionBannerTestIds.asLink}
      noLinkStyle
      onClick={() => trackClick()}
      className={classes(styleVariant === 'dark' && 'px-2 py-1 font-bold')}
    >
      {data.title}
    </Link>
  );
};
